export const state = () => ({
    storefronts: [],
})

export const getters = {
    dsStorefronts: (state) => state.storefronts,
}

export const mutations = {
    setDsStorefronts(state, storefronts) {
        state.storefronts = storefronts
    },
}
